import { isBrowser } from '@phx-husky/browser-helpers';
import { useScreenRecognition } from '@phx-husky/use-screen-recognition';

export const useBrowserScreen = () => {
  const { isMobile, isTablet, isDesktop } = useScreenRecognition();

  const isMobileView = isBrowser() && isMobile;
  const isTabletView = isBrowser() && isTablet;
  const isDesktopView = isBrowser() && isDesktop;

  return { isMobileView, isTabletView, isDesktopView };
};
